import { render, staticRenderFns } from "./InvoiceTemplateSplit.vue?vue&type=template&id=4b6feb4a&scoped=true"
import script from "./InvoiceTemplateSplit.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplateSplit.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplateSplit.vue?vue&type=style&index=0&id=4b6feb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6feb4a",
  null
  
)

export default component.exports